import React from 'react';
import styled from 'styled-components';
import { MICHIGAN_GOV_WEBSITE_URL } from '../../config/index';
import MichiganLogo from './MichiganLogo';
import { getCobrandedSrpLocation } from './util';
import history from '../../core/history';
import { isPhoneOrUndefined } from '../../core/util/device';

const DesktopLogoContainer = styled.div`
  flex-grow: 0;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 30px;
  img {
    height: 50px;
    margin-bottom: 10px;
  }
`;

const MobileLogoContainer = styled.div`
  display: flex;
  padding-top: 16px;
  img {
    height: 36px;
    margin-left: 25px;
  }
`;

const CobrandedSrpLogo = () => {
  const location = getCobrandedSrpLocation();

  const handleLogoOnClick = () => {
    switch (location) {
      case 'MI':
        return window.location.replace(MICHIGAN_GOV_WEBSITE_URL);
      default:
        return history.push('/');
    }
  };

  const getLogo = () => {
    switch (location) {
      case 'MI':
        return <MichiganLogo handleLogoOnClick={handleLogoOnClick} />;
      default:
        return null;
    }
  };

  const logo = getLogo();

  return isPhoneOrUndefined() ? (
    <MobileLogoContainer>{logo}</MobileLogoContainer>
  ) : (
    <DesktopLogoContainer>{logo}</DesktopLogoContainer>
  );
};

export default CobrandedSrpLogo;
